const BASE = (process.env.REACT_APP_API || '').replace(/\/+$/,'')
function join(p){ return BASE + '/' + String(p||'').replace(/^\/+/,'') }

export function authHeader(){
    const t = localStorage.getItem('token')
    return t ? { Authorization: `Bearer ${t}` } : {}
}

export async function api(path, init = {}) {
    const res = await fetch(join(path), {
        ...init,
        headers: { 'Content-Type':'application/json', ...(init.headers||{}), ...authHeader() }
    })
    const ct = res.headers.get('content-type') || ''
    const data = ct.includes('application/json') ? await res.json().catch(()=>null) : await res.text().catch(()=>null)
    if (!res.ok) {
        const msg = data && data.error ? data.error : (typeof data==='string' ? data : `HTTP ${res.status}`)
        throw new Error(msg)
    }
    return data
}
